//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatTime, formatTrueFalse } from '../../components/helpers.js'

export default {
  props: {
    requests: {
      type: Array,
      default () {
        return []
      }
    },
    request: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      columns: [
        {
          name: 'name',
          label: 'Номер',
          align: 'left',
          field: 'name',
          sortable: true
        },
        {
          name: 'createTime',
          label: 'Дата создания',
          align: 'left',
          field: 'createTime',
          format: value => value ? formatTime(value) : '',
          sortable: true
        },
        {
          name: 'stateName',
          label: 'Статус',
          align: 'left',
          field: 'stateName',
          sortable: true
        },
        {
          name: 'typeName',
          label: 'Тип',
          align: 'left',
          field: 'typeName',
          sortable: true
        },
        {
          name: 'external',
          label: 'Внешняя/Внутренняя',
          align: 'left',
          field: 'external',
          format: (value) => value ? 'Внешняя' : 'Внутренняя',
          sortable: true
        },
        {
          name: 'applicantDescription',
          label: 'Описание от заявителя',
          align: 'left',
          field: 'applicantDescription',
          style: 'width: 35%',
          sortable: true
        }
      ],
      pagination: {
        page: 1,
        rowsPerPage: 0 // все строки
      }
    }
  }
}

